<script lang="ts">
    import { Link, navigate, useLocation } from "svelte-navigator";
    import { onMount, afterUpdate, onDestroy, getContext } from "svelte";
    import { api, loader, config, isDisplayedBrandsPopup } from "../stores";
    import type { Category, FilterOptions, Operation, Product } from "../model";
    import ProductCase from "./ProductCase.svelte";
    import ProductCarousel from "./ProductCarousel.svelte";
    import MediaCarousel from "../catalog/MediaCarousel.svelte";

    const { close, open } = getContext("simple-modal");

    const location = useLocation();
    $: () => {
        console.log($location);
    };

    let operation: Operation = null;
    let products: Product[] = null;
    let all_products: Product[] = null;

    let url = window.location.search;
    let body: FilterOptions[] = [];
    let search = false;
    let bodyCat = "all";
    let showedItems = 0;
    let last_scroll;
    let productsDiv;
    let webp;

    let innerWidth = 0;

    let subCategories: Category[] = null;
    let currentSubCategory: string = "all";
    let all_subCategories: Category[] = [];

    /**
     * display promos prodcuts at home products page
     */
    let promosProducts: Product[] = null;
    let showAllProducts = false;

    /**
     * nb products to diaplay in carousel view
     */
    let perPageBrandProducts = 4;

    /**
     * verify if cataglory image existe
     */
    $: haveCategory = verifyCatagoryImageExist(currentSubCategory);

    /**
     * define number of column to products brand carousel
     */
    $: if (innerWidth) {
        if (innerWidth < 650) {
            perPageBrandProducts = 1;
        } else if (innerWidth < 1107) {
            perPageBrandProducts = 2;
        } else if (innerWidth < 1461) {
            perPageBrandProducts = 3;
        } else if (innerWidth < 1815) {
            perPageBrandProducts = 4;
        } else {
            perPageBrandProducts = 5;
        }
    }

    onMount(async () => {
        webp = support_format_webp();
        const processId = $loader.show();
        $api.getOperation().then(
            async (result) => {
                operation = result;
                $loader.hide(processId);
                buildParams();
                all_subCategories = await $api.getSubCategories("all");
                await getProducts();
                if ($api.scrollPositionMosaic !== 0) {
                    setTimeout(() => {
                        // need to what for productsDiv
                        productsDiv.scrollTo({
                            top: $api.scrollPositionMosaic,
                            left: 0,
                            behavior: "auto",
                        });
                    }, 50);
                }
            },
            (err) => {
                console.error(err);
                $loader.hide(processId);
            }
        );
    });

    afterUpdate(async () => {
        if (url !== window.location.search) {
            url = window.location.search;
            buildParams();
            await getProducts();
        }
    });

    onDestroy(async () => {
        const scrollPosition = productsDiv.scrollTop;
        $api.scrollPositionMosaic = scrollPosition;
    });

    /**
     * fetch image to verify if image for category exist
     * @param categoryUid : category uid
     */
    async function verifyCatagoryImageExist(
        categoryUid: string
    ): Promise<boolean> {
        if (categoryUid != "all") {
            return fetch(`/img/categories/${categoryUid}.jpg`)
                .then((res) => {
                    if (res.ok) {
                        return true;
                    } else {
                        return false;
                    }
                })
                .catch((err) => false);
        }

        return Promise.resolve(false);
    }

    function buildParams() {
        const searchParams = new URLSearchParams(window.location.search);
        body = [];
        search = false;
        for (let p of searchParams) {
            switch (p[0]) {
                case "search":
                    search = true;
                    body = [
                        { name: { values: [p[1]], matchLevel: "partially" } },
                        {
                            supplierRef: {
                                values: [p[1]],
                                matchLevel: "partially",
                            },
                        },
                        { brand: { values: [p[1]], matchLevel: "partially" } },
                    ];
                    showAllProducts = true;
                    break;
                default:
                    let filterOptions: FilterOptions = {};
                    filterOptions[p[0]] = {
                        values: [p[1]],
                        matchLevel: "exactly",
                    };

                    if (p[1].indexOf("[") !== -1) {
                        filterOptions[p[0]].values = JSON.parse(p[1]);
                    } else if (p[1].indexOf(",") !== -1) {
                        filterOptions[p[0]].values = p[1].split(",");
                    } else {
                        filterOptions[p[0]].values = [p[1]];
                    }
                    body.push(filterOptions);
                    showAllProducts = true;
                    search = true;
                    break;
            }
        }
    }

    async function getProducts() {
        const processId = $loader.show();
        showedItems = 0;
        $api.getProducts(body).then(
            (result) => {
                showedItems = 0;
                for (
                    let i = showedItems;
                    i < showedItems + (result.length > 15 ? 15 : result.length);
                    i++
                ) {
                    result[i].show = true;
                }
                showedItems = 15;
                products = result;
                all_products = result;
                getSubCategories();

                promosProducts = products.filter((p) => p.meca);
                if (promosProducts.length == 0) {
                    showAllProducts = true;
                }

                // sort list products ( at first promo products, at end other product)
                products.sort((p1, p2) => {
                    let findIndexP1 = promosProducts?.findIndex(
                        (p) => p1.uid == p.uid
                    );
                    let findIndexP2 = promosProducts?.findIndex(
                        (p) => p2.uid == p.uid
                    );

                    // if find inex = -1 put index to infinity
                    if (findIndexP1 == -1)
                        findIndexP1 = Number.MAX_SAFE_INTEGER;
                    if (findIndexP2 == -1)
                        findIndexP2 = Number.MAX_SAFE_INTEGER;

                    if (findIndexP1 < findIndexP2) return -1;
                    if (findIndexP1 > findIndexP2) return 1;
                    if (findIndexP1 == findIndexP2)
                        return p1.name.localeCompare(p2.name);
                });

                if (!$config.config.WebviewTracking) {
                    window.dataLayer.push({
                        event: "ProspectusPage",
                        env: {
                            work: $config.config.Environnment,
                        },
                        page: {
                            name:
                                "/prospectus/" +
                                $api.getOperationCode() +
                                "/pages/ProspectusCategory",
                            type: "ProspectusCategory",
                        },
                        prospectusId: $api.getOperationCode(),
                        shopId: $api.getShopId(),
                    });
                    $api.sendContentSquareEvent();
                }
                $loader.hide(processId);
            },
            (err) => {
                console.error(err);
                $loader.hide(processId);
            }
        );
    }

    function getSubCategories() {
        currentSubCategory = "all";
        bodyCat = "all";
        body.forEach((element) => {
            if (element.categoriesParentUid) {
                bodyCat = element.categoriesParentUid.values[0];
            }
        });

        subCategories = [];
        let subCategories_uids = [];
        products.forEach((product) => {
            let uid = product.categoryChildUid;
            if (subCategories_uids.indexOf(uid) === -1) {
                subCategories_uids.push(uid);
                subCategories.push({
                    uid: uid,
                    name: all_subCategories.find((cat) => cat.uid === uid).name,
                });
            }
        });
        if (subCategories.length === 1) {
            currentSubCategory = subCategories[0].uid;
        }
    }

    function onGetSubCategory() {
        if (currentSubCategory === "all") {
            products = all_products;
        } else {
            products = all_products.filter(
                (product) => product.categoryChildUid == currentSubCategory
            );
            products.forEach((p) => {
                p.show = true;
            });

            showAllProducts = true;
        }
    }

    function goBack(device) {
        if (
            (device === "desktop" ||
                currentSubCategory === "all" ||
                subCategories.length === 1) &&
            search
        ) {
            navigate(-1);
        } else {
            currentSubCategory = "all";
            products = all_products;
        }
    }

    async function wheelEvent(event) {
        if (event.deltaY > 0) {
            displayNextProducts();
        }
    }

    async function handle_scroll() {
        if (productsDiv.scrollTop > last_scroll) {
            displayNextProducts();
        }
        last_scroll = productsDiv.scrollTop;
    }

    function displayNextProducts() {
        if (showedItems < products.length && products.length > 15) {
            products[showedItems].show = true;
            showedItems++;
        }
    }

    function support_format_webp() {
        var elem = document.createElement("canvas");

        if (!!(elem.getContext && elem.getContext("2d"))) {
            // was able or not to get WebP representation
            return elem.toDataURL("image/webp").indexOf("data:image/webp") == 0;
        } else {
            // very old browser like IE 8, canvas not supported
            return false;
        }
    }

    /**
     * return if brand products must be displayed
     * @param brand
     * @param prods
     * @param cat
     */
    function displayBrandProductsCarousel(
        brand: string,
        prods: Product[]
    ): boolean {
        if (!brand || !prods || prods.length == 0) return false;

        let prodsBrand = prods.filter((p) =>
            p.brand.toLocaleLowerCase().includes(brand.toLocaleLowerCase())
        );
        if (prodsBrand.length > 0) {
            return true;
        }

        return false;
    }
</script>

<svelte:window bind:innerWidth/>

<div class="mosaic-products-container">
    <div class="return mt-1 pl-2">
        <span class="desktop" on:click={() => goBack("desktop")}>
            <i class="fas fa-chevron-left" /> Retour
        </span>
        <span class="mobile" on:click={() => goBack("mobile")}>
            <i class="fas fa-chevron-left" /> Retour
        </span>
    </div>
    {#if products !== null}
        <!--  TOP MEDIA CAROUSEL -->
        <!-- {#if currentSubCategory == "all" && !search}
            <div class="top-media-carousel">
                <MediaCarousel />
            </div>
        {/if} -->

        {#if subCategories !== null && !search}
            <div class="filter mt-1">
                <select
                    id="subcat-select"
                    bind:value={currentSubCategory}
                    on:change={() => onGetSubCategory()}
                >
                    {#if subCategories && subCategories.length !== 1}
                        <option value="all" selected>Tous les rayons</option>
                    {/if}
                    {#each subCategories as subCategory}
                        <option value={subCategory.uid}>
                            {subCategory.name}
                        </option>
                    {/each}
                </select>
            </div>
            <div id="mobile-subcategories" class="filtered">
                <!-- <div id="mobile-subcategories" class="{currentSubCategory !== 'all' || bodyCat === "all" ? 'filtered' : ''}"> -->
                {#each subCategories as subCategory}
                    <div
                        class="mobile-subcategory"
                        on:click={() => {
                            currentSubCategory = subCategory.uid;
                            onGetSubCategory();
                        }}
                    >
                        <span>{subCategory.name}</span>
                        <i class="right-arrow fas fa-chevron-right" />
                    </div>
                {/each}
            </div>
        {/if}

        {#if operation && operation.trade_brands && operation.trade_brands.length > 0 && currentSubCategory == "all" && !search}
            <div class="brands-list">
                {#each operation.trade_brands as brand}
                    <div class="brand-space">
                        {#if displayBrandProductsCarousel(brand.name, products)}
                            <h1>L'espace {brand.name}</h1>
                            <ProductCarousel
                                perPage={perPageBrandProducts}
                                products={products.filter(
                                    (p) =>
                                        p.brand.toLowerCase() ==
                                        brand.name.toLowerCase()
                                )}
                                replaceHistory={false}
                            />
                            <div class="bottom">
                                <Link to="../products?brand={brand.name}">
                                    <button class="button see-brand-prods">
                                        Voir tous les produits de la marque
                                        <span class="icon">
                                            <i class="fas fa-arrow-right" />
                                        </span>
                                    </button>
                                </Link>
                            </div>
                        {/if}
                    </div>
                {/each}
            </div>
        {/if}

        <div
            class="products filtered"
            bind:this={productsDiv}
            on:wheel={wheelEvent}
            on:scroll={handle_scroll}
        >
            {#if products.length === 0}
                <h1 class="no-products">
                    Aucun produit ne correspond à votre recherche
                </h1>
            {:else}
                {#if operation && operation.trade_brands && operation.trade_brands.length > 0 && body.length === 1 && body[0]["brand"] && body[0]["brand"]["values"] && body[0]["brand"]["values"][0] && operation.trade_brands.filter( (tb) => {
                            return tb.name.toUpperCase() === body[0]["brand"]["values"][0].toUpperCase();
                        } ).length > 0}
                    <div id="subcategory-visual">
                        <img
                            src={operation.trade_brands.filter((tb) => {
                                return (
                                    tb.name.toUpperCase() ===
                                    body[0]["brand"]["values"][0].toUpperCase()
                                );
                            })[0].ban_url}
                            alt=""
                        />
                    </div>
                {:else if currentSubCategory !== "all" || (subCategories && subCategories.length === 1)}
                    {#await haveCategory then isOk}
                        {#if isOk}
                            <div id="subcategory-visual">
                                <img
                                    src="/img/categories/{currentSubCategory}.jpg"
                                    alt=""
                                />
                            </div>
                        {/if}
                    {/await}
                {/if}
                {#each showAllProducts ? products : promosProducts as product, i}
                    {#if product.show}
                        <ProductCase {product} index={i} />
                    {/if}
                {/each}

                <!-- BUTTON TO SEE ALL PRODUCTS -->
                {#if promosProducts && promosProducts.length > 0 && !showAllProducts}
                    <div
                        class="see-all-cards"
                        on:click={() => (showAllProducts = true)}
                    >
                        Voir tous les produits
                        <span class="icon">
                            <i class="fas fa-arrow-right" />
                        </span>
                    </div>
                {/if}
            {/if}
        </div>
    {/if}
</div>

<style lang="scss">
    @import "../styles/variables.scss";

    .brands-list {
        margin-top: 4rem;
        width: 100%;
        margin-bottom: 4rem;
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 1rem;

        .brand-space {
            display: flex;
            flex-direction: column;
            color: white;
            width: 100%;
            background: linear-gradient(
                61.75deg,
                $dark-black 39.11%,
                black 142.19%
            );
            border-radius: 8px;
            gap: 4px;
            padding: 4px;
        }

        .bottom {
            display: flex;
            margin: 2rem auto;
        }
        .see-brand-prods {
            display: flex;
            margin: auto;
            color: white;
            background-color: $dark-black;
            border: 1px solid white;
            .icon {
                margin: unset !important;
            }
        }

        h1 {
            margin-left: 3rem;
            font-size: 21px;
        }
    }

    .is-mauve-l {
        color: $dark-mauve;
    }

    .see-all-cards {
        width: 97%;
        display: flex;
        flex-direction: row;
        text-align: center;
        align-items: center;
        justify-content: center;
        background-color: $dark-black;
        color: #ffffff;
        font-size: 1.5rem;
        border-radius: 30px;
        cursor: pointer;
        margin: 8px;
        gap: 3px;
        &:hover {
            filter: brightness(85%);
        }
        @media (max-width: $mobile-breakpoint) {
            font-size: 1rem;
        }
    }

    .link-space-trade {
        border-right: 1px solid $dark-mauve;
        border-bottom: 1px solid $dark-mauve;
    }

    .mosaic-products-container {
        background-color: $beige;
        max-height: 100%;
        overflow: auto;
        border-radius: 25px;
    }
    .return {
        width: 50%;
        height: 50px;
        float: left;

        span {
            color: $dark-black;
            font-weight: bold;
            font-size: 1.2em;
            cursor: pointer;

            &.mobile {
                display: none;
            }
        }
    }

    .filter {
        width: 50%;
        height: 50px;
        text-align: end;
        float: right;
        padding-right: 5px;
        #subcat-select {
            border: 1.5px solid $dark-black;
            background-color: transparent;
            color: $dark-black;
            padding: 10px;
            font-weight: 700;
            font-size: 18px;
            border-radius: 10px;
            &:focus,
            :hover {
                outline: none;
            }
        }
    }

    #mobile-subcategories {
        display: none;
    }
    .products {
        height: calc(100% - (50px + 0.25rem + 25px));
        width: 100%;
        overflow: auto;
        overflow-x: hidden;
        // background-color: $light-lavender;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 1rem;
        grid-auto-flow: dense;
        grid-auto-rows: min-content;
        padding: 5px;
        h1.no-products {
            color: $dark-black;
            font-size: 2em;
            font-weight: bold;
            grid-column: 2/4;
            text-align: center;
            @media (max-width: $mobile-breakpoint) {
                grid-column: 1/4;
            }
        }
        #subcategory-visual {
            grid-column: 1/4;
            grid-row: 1;
            img {
                // object-fit: cover;
                height: 100%;
                width: 100%;
                max-height: 350px;
            }
        }
    }

    #price_ref_mentions {
        float: left;
        width: 100%;
    }

    @media (min-width: $mobile-breakpoint) and (max-width: 1350px) {
        .products {
            #subcategory-visual {
                grid-column: 1/4;
                grid-row: 1;
            }
        }
    }

    @media (max-width: $mobile-breakpoint) {
        .return {
            // margin-top: 4rem !important;
            width: 100%;
            height: 30px;

            span {
                &.desktop {
                    display: none;
                }

                &.mobile {
                    display: block;
                }
            }
        }
        .filter {
            display: none;
        }
        #mobile-subcategories {
            display: block;
            float: left;
            width: 100%;
            height: calc(100% - 30px);
            overflow: auto;

            .mobile-subcategory {
                font-size: 1.2em;
                width: 100%;
                padding: 1em;
                float: left;
                color: $dark-black;
                font-weight: 500;
                border-bottom: 1px solid $grey-light;

                span {
                    float: left;
                    max-width: 95%;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                }

                .right-arrow {
                    float: right;
                }
            }
        }
        .products {
            // margin-top: 5rem;

            grid-template-columns: repeat(1, 1fr);
            padding: 1em;
            height: calc(100% - (30px + 0.25rem + 25px));

            #subcategory-visual {
                grid-column: 1/3;
                grid-row: 1;
            }
        }
        #mobile-subcategories.filtered {
            display: none;
        }
        .products:not(.filtered) {
            display: none;
        }
    }

    @media (min-width: $large-screen-breakpoint) {
        .products {
            grid-template-columns: repeat(4, 1fr);

            #subcategory-visual {
                grid-column: 1/5;
                grid-row: 1;
            }
        }
    }

    @media (max-width: 556px) {
        .products {
            #subcategory-visual {
                max-height: 18vh;
            }
        }
    }
</style>
